import { render, staticRenderFns } from "./VisitTrustedPerson.vue?vue&type=template&id=008b663c"
import script from "./VisitTrustedPerson.vue?vue&type=script&lang=js"
export * from "./VisitTrustedPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports